'use client'

import { useSharepointEmbedUrl } from 'lib/api-hooks/sharepointEmbedUrl'
import NextLink from 'next/link'

type Props = {
  sharedUrl: string
}

export default function SharepointStreamEmbed({ sharedUrl }: Props) {
  const { sharepointEmbedUrl, error, notFound, isLoading } =
    useSharepointEmbedUrl(sharedUrl)

  if (isLoading)
    return (
      <span className="bg-gray-hover-light relative flex aspect-video w-full items-center justify-center">
        Video wird geladen...
      </span>
    )
  if (notFound)
    return (
      <span className="bg-gray-hover-light relative flex aspect-video w-full flex-col items-center justify-center gap-2">
        Dieses Video ist nicht mehr verfügbar.
        <NextLink
          href={sharedUrl}
          target="_blank"
          rel="noreferrer"
          className="button-text font-normal underline"
        >
          In SharePoint öffnen
        </NextLink>
      </span>
    )
  if (error)
    return (
      <span className="bg-gray-hover-light relative flex aspect-video w-full items-center justify-center">
        Das Video konnte nicht geladen werden.
      </span>
    )

  return (
    <iframe
      src={sharepointEmbedUrl}
      className="relative aspect-video h-full w-full rounded-lg"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    />
  )
}
